<template>
  <form @submit.stop="onCreate" id="edit-template-modal" class="editor-modal">
        <div class="form-group">
          <h2>{{$t("integration.title")}}</h2>
          <p class="text-muted"> {{$t("integration.category")}} <span >{{contentType.name}}</span></p>
          <div class="checkbox-container">
            <div
              id="contentSourceInput"
              class="checkboxes"
              v-for="source in availableContentSources"
              :key="source.id"
            >
              <checkbox
                :label="source.name"
                :name="source.name"
                :value="source"
                v-model="checkedSources"
              />
            </div>
          </div>
        </div>  

        <div v-if="contentSources == 0" >
          <h5 style="color: #cd4b3d; font-weight: 400;">{{$t("template.no-category-title")}}</h5>
          <span >{{$t("template.cr-tp-no-category")}}</span> 
          <router-link  @click.native="$emit('close')" style="margin-left:4px;" :to="{ name: 'data'}">{{$t('data-walkthrough.routerlink')}}</router-link>
        </div>

        <div class="footer" :class="{noForm :contentSources == 0}" >
           <button
            v-if="contentSources != 0"
            type="submit"
            class="btn btn-md btn-primary"
            :disabled="working || !valid"
            @click="onCreate"
          >
            {{ $t("save") }}
          </button>
          <button
            type="reset"
            class="btn btn-md btn-secondary"
            :disabled="working"
            @click="$emit('close')"
          >
            {{ $t("template.cr-tp-btn-cancel") }}
          </button>
        </div>
    </form>
</template>

<script>
import Checkbox from "@/components/Checkbox";
export default {
  props: {
    contentSources: Array,
    onSave: Function,
    contentType: Object,
    currentIntegrations: Array
  },
  data() {
    return {
      templateName: "",
      contentSource: null,
      language: null,
      working: false,
      isHidden: false,
      checkedSources: []
    };
  },
  computed: {
    valid() {
      return this.checkedSources.length >= 1
    },
    availableContentSources() {
      return !this.contentType
        ? []
        : this.contentSources.filter(
            (cs) => cs.contentType.id === this.contentType.id,
          );
    },
    selectedContentSource() {
      return !this.contentType || this.availableContentSources.length > 1
        ? this.checkedSources
        : [this.availableContentSources[0]];
    },
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.onCreate();
    },
    onCreate(evt) {
      evt.preventDefault();
      this.working = true;
          this.onSave(this.selectedContentSource)
          this.$emit('close')
    },
  },
  created(){
   this.currentIntegrations.forEach( c => {
   this.checkedSources.push( this.availableContentSources.find(a => a.id == c.id) )
   });
  },
  components:{
    Checkbox
  }

};
</script>

<style lang="less">
#edit-template-modal {
  padding: 30px 25px 25px 25px;
  h2 {
    margin: 0;
  }
  p{
      margin-bottom: 10px;
  }
  .noForm{
    margin-top: 30px;
  }
  .checkboxes {
    display: flex;
    flex-direction: row;
  }
}
</style>
